var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMoq(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 250 250",
    style: {
      enableBackground: "new 0 0 250 250"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:#F4BE00;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 125,
    cy: 125,
    r: 125
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M71.4,87.1h-3.8c-2.7,0-5.3,1.1-7.2,3c-1.9-1.9-4.5-3-7.2-3h-3.8c-7.1,0-12.9,5.8-12.9,12.9v46.5 c0,1.6,1.3,3,3,3h7c1.6,0,3-1.3,3-3l-0.1-45c0-1.4,1.2-2.6,2.6-2.6c1.4,0,2.6,1.2,2.6,2.6v45c0,1.6,1.3,3,3,3h2.8h2.8 c1.6,0,3-1.3,3-3v-45c0-1.4,1.2-2.6,2.6-2.6c1.4,0,2.6,1.2,2.6,2.6l-0.1,45c0,1.6,1.3,3,3,3h7c1.6,0,3-1.3,3-3V99.9 C84.2,92.8,78.5,87.1,71.4,87.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M125.6,87.1h-6.4c-11.6,0-21,9.4-21,21v20.4c0,11.6,9.4,21,21,21h6.4c11.6,0,21-9.4,21-21V108 C146.6,96.5,137.2,87.1,125.6,87.1z M132,129.5c0,4.1-3.3,7.4-7.4,7.4h-4.3c-4.1,0-7.4-3.3-7.4-7.4V107c0-4.1,3.3-7.4,7.4-7.4h4.3 c4.1,0,7.4,3.3,7.4,7.4V129.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M189.7,87.1h-6.4c-11.6,0-21,9.4-21,21v20.4c0,10.2,7.3,18.7,17,20.6v6.6c0,12.1,9.8,21.9,21.9,21.9h2.2v-11.8 c-6.2,0-11.3-5.1-11.3-11.3v-0.9c0-2,1.1-3.9,2.9-4.8l0,0c9-2.3,15.7-10.5,15.7-20.3V108C210.7,96.5,201.3,87.1,189.7,87.1z  M196.1,129.5c0,4.1-3.3,7.4-7.4,7.4h-4.3c-4.1,0-7.4-3.3-7.4-7.4V107c0-4.1,3.3-7.4,7.4-7.4h4.3c4.1,0,7.4,3.3,7.4,7.4V129.5z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoq);
export default __webpack_public_path__ + "static/media/moq.69059e758fdd59810f7df9d5f49911ea.svg";
export { ForwardRef as ReactComponent };